export default __webpack_public_path__ + "static/media/archassembly25-logo.04cba7e6.jpeg";